module.exports = __webpack_public_path__ + "public/media/lighted.png";


//////////////////
// WEBPACK FOOTER
// ./images/lighted.png
// module id = ./images/lighted.png
// module chunks = 0